import view from './login'
export default view
